import { post, get, put, del } from '@/utils/request'
import { storage } from '@/plugins/storage'
// // 登录
export const login = async (data) => {
  return post({
    url: '/customerOs/osRegister/osLogin',
    data,
  })
}
///注册
export const register = async (data) => {
  return post({
    url: '/customerOs/osRegister/osRegister',
    data,
  })
}

// 获取用户信息
export const getUserInfo = async (data) => {
  const token = storage.get('TOKEN')
  return get({
    url: '/getInfo',
    data,
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
}

//获取验证码
export const getUserCaptchaImage = async (data) => {
  return get({
    url: '/captchaImage',
    data,
  })
}

//发送验证码接口 
export const getLoginPhoneCode = async (data) => {
  return post({
    url: '/customerOs/osRegister/sendCode2',
    data,
  })
}

//验证码登录 
export const codeLogin = async (data) => {
  return post({
    url: '/customerOs/osRegister/osCodeLogin',
    data,
  })
}

//检测用户手机号是否存在 
export const isLoginPhone = async (data) => {
  return post({
    url: '/customerOs/osRegister/checkIsExistsPhone',
    data,
  })
}

//注册发送验证码 
export const getRegisterPhoneCode = async (data) => {
  return post({
    url: '/customerOs/osRegister/sendCode1',
    data,
  })
}

//判断邮箱是否存在 
export const isRegisterEmail = async (data) => {
  return post({
    url: '/customerOs/osRegister/checkIsExistsEmail',
    data,
  })
}

//用户修改密码接口 
export const updatePassword = async (data) => {
  return post({
    url: '/customerOs/osRegister/osUpdPass',
    data,
  })
}

//检测用户账号是否存在 
export const isLoginUser = async (data) => {
  return post({
    url: '/customerOs/osRegister/checkIsExistsUserName',
    data,
  })
}